import React from 'react'
import Navbar from '../../../components/Navbar'
import Footer from '../../../components/Footer'
import { Typography } from '@mui/material'
import { MEDIA_BASE_URL } from '../../../api'
import '../productPages.css'

const BASE = `${MEDIA_BASE_URL}/machines-images/Cold Stores/Potato Bulk Storage`

const CONCEPT = [
  { img: `${BASE}/astha11.jpg`, caption: '1500 MT potato bulk storage room with pressure wall' },
  { img: `${BASE}/astha22.jpg`, caption: 'Indoor units, waste-heat recovery unit & circulation fans' },
  { img: `${BASE}/astha33.jpg`, caption: 'View without ceiling & rear wall' },
  { img: `${BASE}/astha44.jpg`, caption: 'Outdoor units, cooling tower (view from behind pressure wall)' },
]

const SITE = [
  { img: `${BASE}/astha1.jpeg`, caption: '1500 MT potato bulk storage room with pressure wall' },
  { img: `${BASE}/astha2.jpeg`, caption: 'Circulation fans behind pressure wall' },
  { img: `${BASE}/astha3.jpeg`, caption: 'Outdoor units and cooling tower' },
  { img: `${BASE}/astha4.jpeg`, caption: 'Electrical cum control panel: fully automatic through PLC & cloud monitoring for simultaneous control of temperature, RH & CO₂' },
]

function FigureGrid({ items, wide }) {
  return (
    <div className={`pp-figure-grid${wide ? ' pp-figure-grid-wide' : ''}`}>
      {items.map((f) => (
        <figure className='pp-figure' key={f.img}>
          <img src={f.img} alt={f.caption} loading='lazy' />
          <figcaption>{f.caption}</figcaption>
        </figure>
      ))}
    </div>
  )
}

function Potato() {
  return (
    <>
      <Navbar />

      <main className='page-shell'>
        <div className='page-title-block'>
          <Typography className='page-title'>Potato Bulk Storage</Typography>
          <Typography className='page-subtitle'>Gujarat · 1500 MT × 2</Typography>
        </div>

        <span className='pp-overline'>3D Modelling (Concept)</span>
        <FigureGrid items={CONCEPT} />

        <span className='pp-overline'>Actual Site Pictures</span>
        <FigureGrid items={SITE} wide />
      </main>

      <Footer />
    </>
  )
}

export default Potato
